import Module from '../utils/Module';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class StatsModule extends Module {
  constructor (options) {
    super(options)

    this.DOMEl = options.element;
    this.contentTitle = this.DOMEl.querySelector(".heading__title")
    this.contentText = this.DOMEl.querySelector(".description")
    this.timeline = gsap.timeline().pause();

    this.container = this.DOMEl.querySelector('.inner-stats');
    this.cards = this.container.querySelectorAll(".stats-card");

    this.init();
  }

  init () {
    if(this.contentTitle) this.timeline.to(this.contentTitle, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
    if(this.contentText) this.timeline.to(this.contentText, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');

    const scrollTiggerMain = ScrollTrigger.create({
      trigger: this.DOMEl,
      start: "top center+=100",
      onEnter: ()=>{
        this.timeline.play();
      },
      onEnterBack: ()=>{
        this.timeline.play();
      }
    });


    this.cards.forEach( card  => {

      const timeline = gsap.timeline().pause();

      const titleCards = card.querySelector(".card-title")
      const descCards = card.querySelector(".wysiwyg")

      if(titleCards) timeline.to(titleCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
      if(descCards) timeline.to(descCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');

      const scrollTiggerCards = ScrollTrigger.create({
        trigger: card,
        start: "top center+=100",
        onEnter: ()=>{
          timeline.play();
        },
        onEnterBack: ()=>{
          timeline.play();
        }
      });
    });

    const triggerStatsAnimation = ScrollTrigger.create({
      trigger: this.container,
      start: "top center+=100",
      onEnter: ()=>{
        gsap.to(this.cards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
      },
      onEnterBack: ()=>{
        gsap.to(this.cards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
      }
    });
  }
}
